module.exports = __webpack_public_path__ + "static/media/S (205).ba625ca5.jpg";